<template lang="pug">
  .hello
    br.fat-only
    h1 {{ sify('數學學習診斷是什麼？') }}
    .ui.grid
      .one.column.row
        .column
          .ui.segment.container
            h3 {{ sify('很多數學學習上的問題，都不是新的問題，而是一再重現的「舊的問題」。') }}

            p {{ sify('在教小孩數學的時候，大家都有過這種經驗：講了好幾遍，小孩還是不會。') }}
            p {{ sify('這種情況不但孩子挫折，大人也挫折。這時大人很容易上情緒，甚至會罵小孩「笨」。') }}
            br
            p {{ sify('但是，罵小孩，一點好處都沒有，還不如去想：') }}
            p {{ sify('為什麼這麼簡單的題目他就是搞不懂？') }}
            p {{ sify('為什麼孩子肯努力，卻學不會？') }}
            p {{ sify('怎麼才能讓他學會？') }}
            br
            p {{ sify('這就是為什麼「學習」本身，也需要診斷。') }}

            h3 每個孩子卡關的地方，可能都不一樣

            p {{ sify('同樣一道題目，每個孩子卡關的地方，可能都不一樣。這就代表，我們不能只看表面的對錯，更要去分析錯誤背後的脈絡。') }}

            h4 例題一：「3x+x  >=  -1  >= 1-3x」
            h5 錯誤解法一
            p {{ sify('直接計算')}}
            p {{ sify('4x  >=  -1  >= 1-3x')}}
            p {{ sify('x  >=  -1/4  >= （1-3x）/4')}}
            p {{ sify('然後卡在這一步')}}
            h5 解析一

            p {{ sify('這種連續兩個不等號的式子，其實是兩個不等式聯立。') }}
            p {{ sify('學生不知道遇到這種連在一起的式子，要拆成兩式聯立。怎麼辦呢？') }}
            p {{ sify('我們必須和他溝通，先知道他對不等式的認知、對聯立方程式的認知，之後，才能讓他瞭解「連續兩個不等號的式子，其實是兩個不等式聯立」，要拆成兩個式子，再分別處理。') }}
            h5 錯誤解法二
            p {{ sify('列兩式') }}
            p {{ sify('3x+x  >=  -1 ') }}
            p {{ sify('-1  >= 1-3x') }}

            p {{ sify('把第一式解出來的  x>=-1/4 ') }}  第二式解出來的 x>=2/3，取寬的條件，答為x >=-1/4 

            h5 解析二

            p {{ sify('學生不知道當兩式聯立時，代表這兩式都要同時成立，必須取較嚴苛的範圍，即取 x >= ⅔。') }}
            p {{ sify('遇到這種情況怎麼辦呢？') }}
            p {{ sify('我們必須和他溝通，讓他明白「聯立」代表兩式都要成立，兩個範圍的重疊區域才是題目所要的答案。') }}

            h4 例題二：『有兩種合金各含有20%與50%的銅，兩種應該各用多少公克，才能混合製造出「含銅量42%的合金300公克」？』

            h5 錯誤解法一

            p {{ sify('列式') }}

            p {{ sify('x + y = 0.42') }}
            p {{ sify('0.2x + 0.5y = 300') }}
            h5 解析一

            p {{ sify('學生馬上把20%和50%當作合金中含銅的重量，也就是有一種合金，1公克中含有0.2公克的銅，') }}
            p {{ sify('另一種合金，1公克中含有0.5公克的銅，所以會認為這個題目問的是:「怎麼混合製造出含有300公克銅的合金？') }}
            p {{ sify('而且合金的含銅量是42%。') }}
            br
            p {{ sify('「300公克當然是指混合後的銅重量，怎麼可能是混合後的合金總重量？」這個一種錯誤的想法。') }}
            br
            p {{ sify('依此往下想，方程式的x表示那個含銅量20%的合金，y是含銅量50%的合金，所以x+y=0.42 （的含銅量）和0.2x+0.5y=300（銅的重量 ） 兩式聯立。～～當然怎麼也解不出合理答案的。怎麼辦呢？') }}
            br
            p {{ sify('我們和他溝通的方式是，先從語言翻譯到式子，再從式子翻譯回語言，並且對他示範「如何以正確的方式來翻譯」。') }}
            br
            h5 錯誤解法二
            p {{ sify('列式') }}
            p {{ sify('x + y = 300') }}
            p {{ sify('0.2x + 0.5y = 0.42') }}

            h5 解析二

            p {{ sify('正確的思路是，') }}
            p {{ sify('「300公克當然是混合後的合金總重量」') }}
            p {{ sify('但是，') }}
            p {{ sify('0.2x + 0.5y = 0.42中，左邊是混合後的銅重量，右邊卻是一個混合後比例。正確的式子應該是') }}
            p {{ sify('0.2x + 0.5y = 0.42 × 300') }}
            br
            p {{ sify('這就代表學生對自己寫的式子，代表什麼意思，並沒有十拿九穩的把握。怎麼辦呢？') }}
            p {{ sify('我們還是必須和他溝通，並且示範「如何從語言翻譯到式子，再從式子翻譯回語言的正確方式。」') }}

            h3  面對錯誤

            p {{ sify('很多父母老師，遇到小孩一再犯錯，就會忍不住著急起來。換一兩種教學方法無效後，就難免沮喪挫折，甚至發火罵人。但是，能夠讓他瞭解問題所在，進而改正，才是根本。') }}
            br
            p {{ sify('在糾正偏差行為的部份，有時責罵是有用的，但在知識的學習上，罵從來就是沒有用的。沒有人能夠透過罵的方式，教會孩子數學。') }}
            br
            p {{ sify('既然在知識上，罵沒有用，那要如何面對小孩的計算錯誤呢？') }}
            br
            p {{ sify('數學常見的解題錯誤大至可分為三類，包含閱讀錯誤、計算錯誤、觀念錯誤。') }}

            h4 「閱讀錯誤」
 
            p {{ sify('「閱讀錯誤」是指誤解問題、或無法把問題用數學式表達，造成的錯誤。') }}
            p {{ sify('如果題目要算8的立方根，但是寫的人看成8的平方根，當然後面都會錯。這跟觀念與計算都無關。') }}
 
            p {{ sify('前面的例子中，列式') }}
            p {{ sify('x + y = 0.42') }}
            p {{ sify('0.2x + 0.5y = 300') }}
            p {{ sify('是這類錯誤。') }}
            
            h4 「計算錯誤」
 
            p {{ sify('「計算錯誤」通常被當作粗心大意，似乎只要小心點、多練習就會好。') }}
            br
            p {{ sify('在小學高年級和國中，許多小孩觀念還不錯，卻因計算錯誤而被家長、老師過度指責，造成不必要的挫折感，打擊自信，相當可惜。') }}
            br

            p {{ sify('例如有的人看到30-12，會得出22的答案，他不是不會十位數的計算，只是他視覺太敏感，心算時會直接做十位數的減法，忘了還有個位數。旁觀者當然以為他粗心大意，可是他在第一次自我檢查時還是沒有發現。當他知道自己的計算習慣之後，才能真的解除這種狀況。') }}
            br
            p {{ sify('再如前面的例子中，學生沒有把兩個式子分別處理，而是列式之後直接計算，雖然符合等量公理，但是沒有符合處理聯立式子的程序，以致於卡在第二步，無法繼續。') }}
            p {{ sify('4x  >=  -1  >= 1-3x') }}
            p {{ sify('x  >=  -1/4  >= （1-3x）/4') }}

            p {{ sify('(卡住)') }}

            p {{ sify('就是這類錯誤。') }}

            h4 「觀念錯誤」
 
            p {{ sify('「觀念錯誤」是思路的問題。思路是一個黑箱子，外表看不出來，要請學生繪出或說明他列式背後的想法，才能瞭解問題出在哪裡。') }}
            br
            p {{ sify('為什麼會有觀念錯誤？十之八九，原因就是：先備知識有漏洞。') }}
            br
            p {{ sify('像前面的例子，「300公克當然是指混合後的銅重量，怎麼可能是混合後的合金總重量？」這種思路，就是未能區辨合金總重量和銅重量的觀念錯誤。它所涉及的先備知識，包含比例、重量、總量和加權平均。') }}

            h3 學習診斷的起點

            p {{ sify('數學知識像一張網子，又像一座多尖頂的塔。有學者用鷹架來比喻，很貼切。') }}
            p {{ sify('在這個鷹架中，每一個知識環節，都奠基於幾個比它下位的知識上，我們稱這些更基礎的知識為這個知識的「先備知識」，而那些先備知識，又各自有它們的先備知識...') }}
            br
            p {{ sify('先備知識不牢固，想要更上一層樓，自然就會遇到困難。') }}
            br
            p {{ sify('比方說：要學多位數的乘法（直式），需要哪些先備知識呢？') }}
            br
            p {{ sify('首先，他要懂什麼是乘法、什麼是十進位系統，還要能掌握乘法的分配性（像16乘以5，會等於10乘以5再加上6乘以5），還有乘10、乘100的特殊結果，另外也要會九九乘法表，才能作出完整正確的計算。') }}
            br
            p {{ sify('如果學生在學習直式乘法時發生困難，我會問他和先備知識有關的問題，像是『12乘以100 =?』、『13乘以5  =?』或『你會背九九乘法表嗎？』，逐一過濾，從這些看似簡單的問題，來瞭解他到底是在哪個環節有了漏洞。') }}
            br
            p {{ sify('發現漏洞後，就去處理（教導）這些漏洞處的知識。') }}
            br
            p {{ sify('有些漏洞經過一些引導，小孩能懂，那就可以順利地把漏洞補上。') }}
            p {{ sify('如果還是不懂，那就得重覆前一個步驟，再往回追溯到更基礎的先備知識，一直追溯到「數數兒」都不為過。') }}
            br
            p {{ sify('學習診斷用的是我和佳仁老師共同開發的「中小學攀岩式數學學習地圖」當材料，以互動八法中的「倒溯法」入手。也就是從學生已經學會的數學單元，倒溯尋找先備知識上的洞洞所在。') }}
            br
            p {{ sify('其他更詳細的學習診斷技巧，請參考從') }}
              a(href="https://www.books.com.tw/products/0010687205", target="_blank", rel="noopener noreferrer") 《跟孩子一起玩數學》
              | 一書中，開放摘出的「互動八法」篇章。
    .ui.grid.container
      .three.column.doubling.row
        .column
          router-link(to = "/one1") {{ sify('一、倒溯法')}}
        .column
          router-link(to = "/one2") {{ sify('二、前推法')}}
        .column
          router-link(to = "/one3") {{ sify('三、具體經驗')}}
        .column
          router-link(to = "/one4") {{ sify('四、繞道法--渡過心理障礙')}}
        .column
          router-link(to = "/one5") {{ sify('五、主客易位法')}}
        .column
          router-link(to = "/one6") {{ sify('六、面對錯誤')}}
        .column
          router-link(to = "/one7") {{ sify('七、適度的練習')}}
        .column
          router-link(to = "/one8") {{ sify('八、互為主體、交互佈題法')}}
        .column
          router-link(to = "/one9") {{ sify('數學學習診斷是什麼？')}}


</template>

<script>

import {sify} from 'chinese-conv'

export default {
  name: '數學學習診斷是什麼？',
  props: ['si'],
  data () {
    return {
    }
  },
  methods: {
    sify (t) {
      if (this.si) {
        return sify(t)
      } else {
        return t
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.column {
  text-align: left;
}

a {
  text-decoration: underline;
}
</style>
